import { Component, Injectable, OnInit, Input, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../../../common/services/User.service';
import { BsModalService } from 'ngx-bootstrap';
import { OrganizeService } from '../../../../common/services/Organize.service';
import { ToastrService } from 'ngx-toastr';
import { TicketService } from '../../../../common/services/Ticket.service';
import { UserSharedService } from '../customer/UserSharedService';
import { showPhoneNumberInString } from '../../../../common/utils/common';
import { BaseComponent } from '../../../../components/base.component';

declare var $: any;
declare const Timer: any;

@Component({
  moduleId: module.id,
  selector: 'detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.css'],
  providers: [UserService, BsModalService, OrganizeService, TicketService],
})
@Injectable()
export class DetailComponent extends BaseComponent {
  @Input() data;
  @Input() tabIndex;

  public no_image: any = 'assets/images/contact.png';
  public domain: string;
  public modelOrganize: any = {};
  public modalRef: any;
  public organize: any;
  public ticket: any;
  public tab: string; // ticket, user, organize
  public owner: any;
  public message: any = null;

  @ViewChild('templateOrganize') templateOrganize: ElementRef;
  public readonly showPhoneNumberInString = showPhoneNumberInString;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private userService: UserService,
    private organizeService: OrganizeService,
    private ticketService: TicketService,
    private shareService: UserSharedService
  ) {
    super(changeDetector, toastr, modalService);
    this.shareService.onChangetab.subscribe(data => {
      this.changeTab(data);
    });
  }

  ngOnInit() {
    if (this.data.type == 'ticket') {
      this.tab = 'ticket';
      if (this.data.detail) {
        const detail = this.data.detail.request || {};
        if (detail.email) {
          const arr = detail.email.split('@');
          if (arr.length == 2) {
            this.domain = arr[1];
          }
        }
        if (detail.organize_id) {
          this.organizeService.find(detail.organize_id).subscribe(res => {
            if (res.status == 200 && res.error == false) {
              this.organize = res.data;
            }
          });
        }
        this.owner = detail;
      }
    }
    if (this.data.type == 'user') {
      this.tab = 'user';
      const detail = this.data.detail || {};
      if (detail.email) {
        const arr = detail.email.split('@');
        if (arr.length == 2) {
          this.domain = arr[1];
        }
      }

      if (detail.organize_id) {
        this.organizeService.find(detail.organize_id).subscribe(res => {
          if (res.status == 200 && res.error == false) {
            this.organize = res.data;
          }
        });
      }
      if (!detail.tags) {
        detail.tags = [];
      }
      this.owner = detail;
    }
    if (this.data.type == 'organize') {
      this.tab = 'organize';
      this.organize = this.data.detail;
    }
  }

  changeTab(tab) {
    this.tab = tab;
  }

  openCreateOrganize() {
    this.message = null;
    this.modelOrganize = {
      name: '',
      domain: '',
    };
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef = this.modalService.show(this.templateOrganize, config);
  }

  addOrganize() {
    this.organizeService.create(this.modelOrganize).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          let _user_id;
          if (this.data.type == 'user') {
            _user_id = this.data.detail._id;
          } else if (this.data.type == 'ticket') {
            _user_id = this.data.detail.requester_id;
          }

          this.userService.update(_user_id, { organize_id: res.data.id }).subscribe(rs => {
            if (res.status == 200 && res.error == false) {
              this.organize = res.data;
              this.modalRef.hide();
            } else {
              this.toastr.error('Lưu không thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            }
          });
        } else {
          this.toastr.error('Lưu không thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        setTimeout(() => (this.message = null), 3000);
      }
    );
  }

  triggerBackUser($event) {
    // refresh User
    this.userService.find({ _id: $event.requester_id }).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.owner = res.data;
        this.data.detail.request = res.data;
        if (this.owner.organize_id) {
          this.organizeService.find(this.owner.organize_id).subscribe(res => {
            if (res.status == 200 && res.error == false) {
              this.organize = res.data;
            }
          });
        }
      }
    });
  }

  triggerBackOrganize($event) {
    // refresh Organize
    this.organizeService.find($event.organize_id).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.organize = res.data;
      }
    });
  }

  triggerBack($event) {
    if ($event.ticket) {
      if ($event.ticket.request.organize_id) {
        this.organizeService.find($event.ticket.request.organize_id).subscribe(res => {
          if (res.status == 200 && res.error == false) {
            this.organize = res.data;
          }
        });
      }
      this.data = {
        type: 'ticket',
        action: 'edit',
        detail: $event.ticket,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/detail.component.ts